function useif(value, useIfNotEmpty) {
    if (useIfNotEmpty === void 0) { useIfNotEmpty = null; }
    return value ?
        useIfNotEmpty :
        null;
}
function hasFlag(state, stateFlag) {
    return (state & stateFlag) !== 0;
}
function addMonths(date, months) {
    var dateCopy = new Date(date.getTime());
    var d = dateCopy.getDate();
    dateCopy.setMonth(dateCopy.getMonth() + months);
    if (dateCopy.getDate() != d) {
        dateCopy.setDate(0);
    }
    return dateCopy;
}
export { addMonths, hasFlag, useif, };
